/*
  Copyright (c) 2018-present, Accuracy.
  All rights reserved.
*/

/**
 * Resolves a path under `public/api/...` (e.g. `'api/getComments.php'`) to
 * an absolute URL honouring the app's homepage prefix (`process.env.PUBLIC_URL`),
 * the same way `asset()` does for `public/files/...` — see that file for why
 * a plain relative path breaks depending on the current route.
 */
export const apiUrl = (path: string): string => `${process.env.PUBLIC_URL}/${path.replace(/^\/+/, '')}`;
